import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

import Select from '../../../components/ui/Select';

const ProfileCustomization = ({ userData, onProfileUpdate }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [customization, setCustomization] = useState({
    bio: userData?.bio || '',
    skillLevel: userData?.skillLevel || '',
    preferredPositions: userData?.preferredPositions || [],
    playingStyle: userData?.playingStyle || '',
    availability: userData?.availability || [],
    favoriteVenues: userData?.favoriteVenues || []
  });

  const skillLevels = [
    { value: 'iniciante', label: 'Iniciante' },
    { value: 'intermediario', label: 'Intermediário' },
    { value: 'avancado', label: 'Avançado' },
    { value: 'profissional', label: 'Profissional' }
  ];

  const positions = [
    { value: 'goleiro', label: 'Goleiro' },
    { value: 'zagueiro', label: 'Zagueiro' },
    { value: 'lateral', label: 'Lateral' },
    { value: 'volante', label: 'Volante' },
    { value: 'meio-campo', label: 'Meio-campo' },
    { value: 'atacante', label: 'Atacante' }
  ];

  const playingStyles = [
    { value: 'tecnico', label: 'Técnico' },
    { value: 'fisico', label: 'Físico' },
    { value: 'velocidade', label: 'Velocidade' },
    { value: 'lideranca', label: 'Liderança' },
    { value: 'criativo', label: 'Criativo' },
    { value: 'defensivo', label: 'Defensivo' }
  ];

  const weekDays = [
    { value: 'segunda', label: 'Segunda' },
    { value: 'terca', label: 'Terça' },
    { value: 'quarta', label: 'Quarta' },
    { value: 'quinta', label: 'Quinta' },
    { value: 'sexta', label: 'Sexta' },
    { value: 'sabado', label: 'Sábado' },
    { value: 'domingo', label: 'Domingo' }
  ];

  const venues = [
    { value: 'campo-morumbi', label: 'Campo do Morumbi' },
    { value: 'arena-central', label: 'Arena Central' },
    { value: 'quadra-vila', label: 'Quadra da Vila' },
    { value: 'futebol-clube', label: 'Futebol Clube' }
  ];

  const handleInputChange = (field, value) => {
    setCustomization(prev => ({ ...prev, [field]: value }));
  };

  const handleArrayToggle = (field, value) => {
    setCustomization(prev => ({
      ...prev,
      [field]: prev?.[field]?.includes(value)
        ? prev?.[field]?.filter(item => item !== value)
        : [...(prev?.[field] || []), value]
    }));
  };

  const handleSave = () => {
    onProfileUpdate(customization);
    setIsExpanded(false);
  };

  const handleReset = () => {
    setCustomization({
      bio: userData?.bio || '',
      skillLevel: userData?.skillLevel || '',
      preferredPositions: userData?.preferredPositions || [],
      playingStyle: userData?.playingStyle || '',
      availability: userData?.availability || [],
      favoriteVenues: userData?.favoriteVenues || []
    });
    setIsExpanded(false);
  };

  const getSkillLevelColor = (level) => {
    switch (level?.toLowerCase()) {
      case 'profissional': return 'text-purple-600 bg-purple-100';
      case 'avancado': return 'text-red-600 bg-red-100';
      case 'intermediario': return 'text-blue-600 bg-blue-100';
      default: return 'text-green-600 bg-green-100';
    }
  };

  const getStyleIcon = (style) => {
    switch (style?.toLowerCase()) {
      case 'tecnico': return 'Brain';
      case 'fisico': return 'Zap';
      case 'velocidade': return 'Wind';
      case 'lideranca': return 'Crown';
      case 'criativo': return 'Sparkles';
      case 'defensivo': return 'Shield';
      default: return 'User';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-2 overflow-hidden">
      {/* Header */}
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <h2 className="font-heading font-bold text-lg text-card-foreground">
            Personalização
          </h2>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'}
            iconPosition="left"
            iconSize={16}
          >
            {isExpanded ? 'Recolher' : 'Expandir'}
          </Button>
        </div>
      </div>
      {/* Current Settings Preview */}
      {!isExpanded && (
        <div className="p-4 space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Nível:</span>
            <span className={`px-2 py-1 text-xs rounded-full ${getSkillLevelColor(userData?.skillLevel)}`}>
              {userData?.skillLevel || 'Não definido'}
            </span>
          </div>
          
          {userData?.preferredPositions?.length > 0 && (
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Posições:</span>
              <div className="flex space-x-1">
                {userData?.preferredPositions?.slice(0, 2)?.map((position) => (
                  <span key={position} className="px-2 py-1 text-xs bg-muted rounded-full text-muted-foreground">
                    {position}
                  </span>
                ))}
                {userData?.preferredPositions?.length > 2 && (
                  <span className="px-2 py-1 text-xs bg-muted rounded-full text-muted-foreground">
                    +{userData?.preferredPositions?.length - 2}
                  </span>
                )}
              </div>
            </div>
          )}
          
          {userData?.playingStyle && (
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Estilo:</span>
              <div className="flex items-center space-x-2">
                <Icon name={getStyleIcon(userData?.playingStyle)} size={14} className="text-primary" />
                <span className="text-sm text-card-foreground">{userData?.playingStyle}</span>
              </div>
            </div>
          )}
        </div>
      )}
      {/* Expanded Settings */}
      {isExpanded && (
        <div className="p-4 space-y-6">
          {/* Bio Section */}
          <div>
            <label className="block text-sm font-medium text-card-foreground mb-2">
              Biografia
            </label>
            <textarea
              placeholder="Conte um pouco sobre seu estilo de jogo, experiência e preferências..."
              value={customization?.bio}
              onChange={(e) => handleInputChange('bio', e?.target?.value)}
              rows={3}
              maxLength={200}
              className="w-full px-3 py-2 text-sm border border-input rounded-lg bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
            />
            <div className="flex justify-between items-center mt-1">
              <span className="text-xs text-muted-foreground">
                Descreva seu perfil como jogador
              </span>
              <span className="text-xs text-muted-foreground">
                {customization?.bio?.length || 0}/200
              </span>
            </div>
          </div>

          {/* Skill Level */}
          <div>
            <label className="block text-sm font-medium text-card-foreground mb-2">
              Nível de Habilidade
            </label>
            <Select
              options={skillLevels}
              value={customization?.skillLevel}
              onChange={(value) => handleInputChange('skillLevel', value)}
              placeholder="Selecione seu nível"
            />
          </div>

          {/* Preferred Positions */}
          <div>
            <label className="block text-sm font-medium text-card-foreground mb-2">
              Posições Preferidas
            </label>
            <div className="grid grid-cols-2 gap-2">
              {positions?.map((position) => (
                <button
                  key={position?.value}
                  onClick={() => handleArrayToggle('preferredPositions', position?.label)}
                  className={`px-3 py-2 text-sm rounded-lg border transition-standard text-left ${
                    customization?.preferredPositions?.includes(position?.label)
                      ? 'bg-primary text-primary-foreground border-primary'
                      : 'bg-background text-foreground border-input hover:border-primary'
                  }`}
                >
                  {position?.label}
                </button>
              ))}
            </div>
          </div>

          {/* Playing Style */}
          <div>
            <label className="block text-sm font-medium text-card-foreground mb-2">
              Estilo de Jogo
            </label>
            <div className="grid grid-cols-2 gap-2">
              {playingStyles?.map((style) => (
                <button
                  key={style?.value}
                  onClick={() => handleInputChange('playingStyle', style?.label)}
                  className={`flex items-center space-x-2 px-3 py-2 text-sm rounded-lg border transition-standard ${
                    customization?.playingStyle === style?.label
                      ? 'bg-primary text-primary-foreground border-primary'
                      : 'bg-background text-foreground border-input hover:border-primary'
                  }`}
                >
                  <Icon name={getStyleIcon(style?.label)} size={16} />
                  <span>{style?.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Availability */}
          <div>
            <label className="block text-sm font-medium text-card-foreground mb-2">
              Disponibilidade
            </label>
            <div className="grid grid-cols-2 gap-2">
              {weekDays?.map((day) => (
                <button
                  key={day?.value}
                  onClick={() => handleArrayToggle('availability', day?.label)}
                  className={`px-3 py-2 text-sm rounded-lg border transition-standard ${
                    customization?.availability?.includes(day?.label)
                      ? 'bg-success text-success-foreground border-success'
                      : 'bg-background text-foreground border-input hover:border-success'
                  }`}
                >
                  {day?.label}
                </button>
              ))}
            </div>
          </div>

          {/* Favorite Venues */}
          <div>
            <label className="block text-sm font-medium text-card-foreground mb-2">
              Locais Favoritos
            </label>
            <div className="space-y-2">
              {venues?.map((venue) => (
                <button
                  key={venue?.value}
                  onClick={() => handleArrayToggle('favoriteVenues', venue?.label)}
                  className={`flex items-center space-x-3 w-full px-3 py-2 text-sm rounded-lg border transition-standard text-left ${
                    customization?.favoriteVenues?.includes(venue?.label)
                      ? 'bg-secondary text-secondary-foreground border-secondary'
                      : 'bg-background text-foreground border-input hover:border-secondary'
                  }`}
                >
                  <Icon name="MapPin" size={16} />
                  <span>{venue?.label}</span>
                  {customization?.favoriteVenues?.includes(venue?.label) && (
                    <Icon name="Check" size={16} className="ml-auto" />
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex space-x-3 pt-4 border-t border-border">
            <Button
              variant="default"
              onClick={handleSave}
              iconName="Save"
              iconPosition="left"
              iconSize={16}
              className="flex-1"
            >
              Salvar Alterações
            </Button>
            <Button
              variant="outline"
              onClick={handleReset}
              iconName="RotateCcw"
              iconPosition="left"
              iconSize={16}
              className="flex-1"
            >
              Cancelar
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileCustomization;